import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const TawkController = () => {
  const location = useLocation();

  useEffect(() => {
    const tawkScript = document.getElementById("tawkhide");

    if (location.pathname.includes("/view-reports")) {
      // Hide Tawk.to on report page
      if (tawkScript) {
        tawkScript.parentNode.removeChild(tawkScript);
      }
    } else {
      // Show Tawk.to on other pages
      if (!tawkScript) {
        const script = document.createElement("script");
        script.id = "tawkhide";
        script.async = true;
        script.src =
          "https://embed.tawk.to/629f95137b967b1179935cdc/1g4vlslse";
        script.charset = "UTF-8";
        script.setAttribute("crossorigin", "*");
        document.head.appendChild(script);
      }
    }
  }, [location.pathname]);

  return null; // no UI
};

export default TawkController;